@for (org of organizations(); track org.id; let idx = $index) {
  <div class="mb-3">
    @if (isEPS(org)) {
      <div class="section-header-cyan">EPS #{{ idx + 1 }}</div>
    } @else {
      <div class="section-header-gray">Organizacion prestadora de salud #{{ idx + 1 }}</div>
    }
    <div class="section-body">
      @if (org.name) {
        <p class="mb-2"><strong>Nombre:</strong> {{ org.name }}</p>
      }
      @if (getNIT(org)) {
        <p class="mb-2"><strong>NIT:</strong> {{ getNIT(org) }}</p>
      }
      @if (getCodigo(org)) {
        <p class="mb-2"><strong>Código de habilitación (REPS):</strong> {{ getCodigo(org) }}</p>
      }
      @if (getOrgType(org)) {
        <p class="mb-2"><strong>Tipo de organización:</strong> {{ getOrgType(org) }}</p>
      }
    </div>
  </div>
  @if (!$last) {
    <hr />
  }
}
